var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isVue2, h as _h } from 'vue-demi';
import ReactiveField from './ReactiveField';
import { getRawComponent } from '../utils/getRawComponent';
import { getVoidFieldProps } from '../utils/getFieldProps';
var VoidField;
/* istanbul ignore else */
if (isVue2) {
    VoidField = {
        functional: true,
        name: 'VoidField',
        props: getVoidFieldProps(),
        render: function (h, context) {
            var props = context.props;
            var attrs = context.data.attrs;
            var componentData = __assign(__assign({}, context.data), { props: {
                    fieldType: 'VoidField',
                    fieldProps: __assign(__assign(__assign({}, attrs), props), getRawComponent(props)),
                } });
            return _h(ReactiveField, componentData, context.children);
        },
    };
}
else {
    VoidField = {
        name: 'VoidField',
        props: getVoidFieldProps(),
        setup: function (props, context) {
            return function () {
                var componentData = {
                    fieldType: 'VoidField',
                    fieldProps: __assign(__assign({}, props), getRawComponent(props)),
                };
                return _h(ReactiveField, componentData, context.slots);
            };
        },
    };
}
export default VoidField;
//# sourceMappingURL=VoidField.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/vue/esm/components/VoidField.js
// module id = null
// module chunks = 